import { ColliTypeSelect } from '@frontend/colli/select';
import { NumberInput, TextArea } from '@frontend/components/basic-forms';
import { ICONS, Minus, Package, Plus } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { FaCheck } from 'react-icons/fa6';
import { FormattedMessage } from 'react-intl';

import { useWizardModalScreenNavigation } from '../../wizard-modal-navigation.context';
import useEnterParcelInformation from './enter-parcel-information.controller';

const ID = 'enter-parcel-information';

const EnterParcelInformation = (props: { wizard_id: string }) => {
    const viewProps = useEnterParcelInformation(props);

    useWizardModalScreenNavigation({
        onContinue: viewProps.onSubmit,
        continueDisabled: viewProps.submitDisabled
    });

    return (
        <div
            id={ID}
            className='flex w-full flex-col gap-3'>
            <div className='flex items-start justify-start self-stretch'>
                <div className='text-foreground-default justify-start text-base font-medium'>{CommonMessage.FORMS.PROVIDE_THE_FOLLOWING}</div>
            </div>

            {viewProps.showColliFields && (
                <div
                    data-state='Open'
                    className='outline-border-default inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4 outline-1'>
                    <div className='inline-flex items-center justify-between self-stretch'>
                        <div className='flex items-center justify-start gap-4'>
                            <div className='outline-border-default relative flex size-12 items-center justify-center rounded-full outline-2'>
                                <FaCheck className='bg-status-success text-background-surface absolute top-0 right-0 size-4 rounded-full p-0.5' />
                                <Package className='size-1/2' />
                            </div>
                            <div className='inline-flex flex-col items-start justify-center gap-1'>
                                <div className='text-foreground-default justify-start text-base font-semibold'>{CommonMessage.OBJECTS.PARCEL.PLURAL}</div>
                            </div>
                        </div>
                    </div>

                    <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                        <div className='text-foreground-default justify-start text-base font-medium'>
                            <FormattedMessage
                                id='mobile.wizard.enter-parcel-information.parcel-amount'
                                description='Label for parcel'
                                defaultMessage='Amount of parcels'
                            />
                        </div>
                        <div className='inline-flex items-start justify-start gap-2 self-stretch'>
                            <NumberInput
                                value={viewProps.quantity}
                                onChange={viewProps.setQuantity}
                                className='flex-1'
                            />
                            <button
                                disabled={viewProps.quantity <= 1}
                                onClick={() => viewProps.setQuantity(viewProps.quantity > 1 ? viewProps.quantity - 1 : 1)}
                                className='outline-border-default disabled:bg-brand-disabled flex size-11 items-center justify-between overflow-hidden rounded-md px-4 outline-1 outline-offset-[-1px] hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-30'>
                                <Minus className='size-5' />
                            </button>
                            <button
                                onClick={() => viewProps.setQuantity(viewProps.quantity + 1)}
                                className='outline-border-default flex size-11 items-center justify-between overflow-hidden rounded-md px-4 outline-1 outline-offset-[-1px] hover:cursor-pointer disabled:cursor-not-allowed'>
                                <Plus className='size-5' />
                            </button>
                        </div>
                    </div>

                    <div className='inline-flex flex-col items-start justify-start gap-2 self-stretch'>
                        <div className='text-foreground-default justify-start text-base font-medium'>{CommonMessage.FORMS.TYPE}</div>
                        <ColliTypeSelect
                            className='w-full'
                            hideLabel
                            value={viewProps.type}
                            onSelect={(v) => viewProps.setType(v?.value || null)}
                        />
                    </div>
                </div>
            )}

            <div
                data-state='Open'
                className='outline-border-default inline-flex flex-col items-start justify-start gap-5 self-stretch rounded-xl p-4 outline-1'>
                <div className='text-foreground-default flex w-full flex-row justify-between text-base font-semibold'>
                    {CommonMessage.OBJECTS.TRANSACTION.COMMENTS}
                    <span
                        className='hover:text-brand-primary hover:cursor-pointer'
                        onClick={() => viewProps.setHideCommentsHelp(!viewProps.hideCommentsHelp)}>
                        <ICONS.BUTTON.INFO className='size-5' />
                    </span>
                </div>
                {!viewProps.hideCommentsHelp && (
                    <div className='text-brand-muted justify-start self-stretch text-base font-medium'>
                        <FormattedMessage
                            id='wizard.enterParcelInformation.comments'
                            defaultMessage='You can add additional comments to the transaction. These comments will be visible to the receiver(s).'
                            description='The helpmessage for adding comments to the transaction'
                        />
                    </div>
                )}

                <TextArea
                    value={viewProps.comments}
                    onChange={viewProps.setComments}
                    label={undefined}
                    submitted={false}
                    className='self-stretch'
                />
            </div>
        </div>
    );
};

export default EnterParcelInformation;
